<template>
  <CommonModal>
    <template slot="header">
      <h3>Add Model Code</h3>
    </template>
    <template slot="body">
      <div>
        <table class="write_tbl">
          <tbody>
            <tr>
              <th>이름</th>
              <td>
                <input
                  type="text"
                  name="doctypeName"
                  class="form-control"
                  v-model="form.modelcodeVO.modelcodeName"
                  v-validate="'required'"
                />
              </td>
            </tr>
            <tr>
              <th>설명</th>
              <td colspan="2">
                <textarea
                  class="form-control"
                  name="doctypeDesc"
                  v-model="form.modelcodeVO.modelcodeDesc"
                ></textarea>
              </td>
            </tr>
            <tr>
              <th>사용여부</th>
              <td>
                <label
                  ><input
                    type="radio"
                    name="useYn"
                    v-model="form.modelcodeVO.useYn"
                    value="Y"
                  />
                  Use</label
                >
                <label
                  ><input
                    type="radio"
                    name="useYn"
                    v-model="form.modelcodeVO.useYn"
                    value="N"
                  />
                  Unused</label
                >
              </td>
            </tr>
          </tbody>
        </table>

        <!-- <table class="write_tbl" v-for="(item, index) in form.languages" :key="index">
          <tbody>
            <tr>
              <th>언어</th>
              <td>
                {{ item.language.codeName }}
              </td>
            </tr>
            <tr>
              <th>이름</th>
              <td>
                <input
                  type="text"
                  name="doctypeName"
                  class="form-control"
                  v-model="item.name"
                  v-validate="item.language.codeId == 'en' ? 'required' : ''"
                />
              </td>
            </tr>
            <tr>
              <th>설명</th>
              <td colspan="2">
                <textarea
                  class="form-control"
                  name="doctypeDesc"
                  v-model="item.desc"
                ></textarea>
              </td>
            </tr>
          </tbody>
        </table> -->
      </div>
    </template>
    <template slot="footer">
      <slot name="footer"> </slot>
    </template>
  </CommonModal>
</template>

<script>
import CommonModal from "@/components/modal/CommonModal";
import {
  fetchModelCodeForm,
  addModelCode,
  checkModelNameDuplication,
} from "@/api/modelcode";

export default {
  components: {
    CommonModal,
  },
  data() {
    return {
      form: {
        modelcodeVO: {
          modelcodeId: "",
          modelcodeName: "",
          modelcodeDesc: "",
          useYn: "",
        },

        languages: [],
      },
      modelCode: "",
    };
  },
  methods: {
    async save() {
      const validForm = await this.$validator.validateAll();
      if (validForm) {
        //modelCodeName 중복확인
        const { data } = await checkModelNameDuplication(this.form);
        this.modelCode = data.modelCode;
        if (
          this.modelCode == null ||
          this.modelCode == "" ||
          this.modelCode.length == 0
        ) {
          try {
            const response = await addModelCode(this.form);
            return response.data.status;
            // if (response.data.success) {
            //   this.reset();
            // }
          } catch (error) {
            console.log(error);
          }
        } else {
          return "exist";
          // alert(this.$t("alert.alreadyExist"));
        }
      } else {
        return "value";
        // alert(this.$t("alert.plzCheckAllValues"));
      }
    },
    reset() {
      this.form.modelcodeVO.modelcodeId = "";
      this.form.modelcodeVO.modelcodeName = "";
      this.form.modelcodeVO.modelcodeDesc = "";
      this.form.modelcodeVO.useYn = "Y";
    },
    async fetchProdTypeForm(upperId, level) {
      const response = await fetchModelCodeForm(upperId, level);
      console.log(response);
      this.form = response.data;
      this.form.modelcodeVO.useYn = "Y";
    },
  },
};
</script>

<style></style>
